import { TutorialConfig } from "../types/tutorial";

const routeOptimizationTutorial: TutorialConfig = {
  pageId: "route-optimization",
  pageTitle: "Route Optimization",
  steps: [
    {
      id: "route-intro",
      title: "Compare Routes",
      description:
        "Find the best shipping route by balancing cost, transit time, distance, and reliability.",
      targetSelector: '[data-tutorial-step="route-header"]',
      position: "bottom",
    },
    {
      id: "route-analyzer",
      title: "Scenario Builder",
      description:
        "Enter product, destination, quantity, and optimization strategy. The example uses Alloy Pig Iron Furnace Charge Blocks to Chicago, 1,500 units, optimized by cost.",
      targetSelector: '[data-tutorial-step="route-analyzer"]',
      position: "right",
      example: {
        product: "Alloy Pig Iron Furnace Charge Blocks",
        destination: "Chicago",
        quantity: "1500",
        strategy: "cost",
      },
    },
    {
      id: "route-apply",
      title: "Generate Routes",
      description:
        "Click Apply Filters to generate route options based on the selected product, destination, quantity, and strategy.",
      targetSelector: '[data-tutorial-step="route-primary-action"]',
      position: "right",
    },
    {
      id: "route-map",
      title: "Route Map",
      description:
        "The map visualizes the currently selected route on a globe. Hover or click a leg to inspect the transport mode and waypoints.",
      targetSelector: '[data-tutorial-step="route-map"]',
      position: "left",
    },
    {
      id: "route-card",
      title: "Compare Route Options",
      description:
        "Each card summarizes a generated route with its cost, risk, transit time, and distance. Click Select Route on the recommended option to open its full breakdown.",
      targetSelector: '[data-tutorial-step="route-select-row"]',
      position: "left",
    },
    {
      id: "route-selected-scenario",
      title: "Selected Scenario",
      description:
        "This panel shows why the route was recommended, along with detailed shipment, product, tariff, and total cost breakdowns for the selected scenario.",
      targetSelector: '[data-tutorial-step="route-selected-scenario"]',
      position: "left",
    },
  ],
};

export default routeOptimizationTutorial;
